import React from 'react'
import * as THREE from 'three'
import { useFrame, useThree } from '@react-three/fiber'
import useStore from "../../StateStore/store.js"

let angle = 0

const WalkableArea = ({size}) => {

    const ref = React.useRef()

    const teleport = useStore(state => state.playerTeleport.teleportTo)
    const teleportation = useStore(state => state.playerTeleport)
    const teleportState = useStore(state => state.playerTeleport.teleportState)
    const setTeleport = useStore(state => state.playerTeleport.setTeleport)
    const pan = useStore(state => state.pan.panEnable)
    
    const {camera} = useThree()

    const clicked = (e) => {
            if(pan === false){
                const cameraPosition = camera.position
                const teleportPosition = new THREE.Vector3(e.point.x, 0.11, e.point.z)
                const distToTravel = cameraPosition.distanceTo(teleportPosition)
                teleport(teleportPosition, distToTravel)
                setTeleport(true)
                
            }

    }

    const hover = () => {
        document.body.style.cursor = "pointer"
    }

    const pointerOut = () => {
        document.body.style.cursor = "default"
    }

    useFrame(() => {
        ref.current.material.opacity = (Math.sin(angle)+1)/50 + 0.02
        angle += 0.035
    })

    return (
        <>
            <mesh
                ref= {ref}
                onClick={(e) => clicked(e)}
                rotation={[Math.PI/2, 0, 0]}
                onPointerOver={e => hover(e)}
                onPointerOut={pointerOut}
                position={[0, 0.1, 0]}
            >
                <planeBufferGeometry args = {[size, 100]} />
                <meshBasicMaterial  transparent color={"yellow"} side={THREE.DoubleSide} opacity={0.1} />
            </mesh>
        </>
    )
}

export default WalkableArea
